import { getToken } from "./api-account";

export const BASE_URL: string = 
     process.env.REACT_APP_IS_PROXY === 'true'
         ? 'https://localhost:5001/api'
         : '/api';

console.log(`Node Environment: ${process.env.NODE_ENV}`)
console.log(`API URL: ${BASE_URL}`)

export interface ErrorResult {
    message: string,
    detail: string
}

export interface ApiResult<T> {
    success: boolean;
    error?: ErrorResult;
    data?: T;
}

function buildRequest(requestUrl: string, method: string = 'get', body?: any): Request {
    let headers: Headers = new Headers();
    headers.append('Accept', 'application/json');
    const token: string | null = getToken();
    if (token) {
        headers.append('Authorization', `Bearer ${token}`);
    }

    let bodyStringified: string | undefined = undefined;

    if (body) {
        bodyStringified = JSON.stringify(body);
        headers.append('Content-Type', 'application/json');
    }

    return new Request(requestUrl, {
        method: method,
        body: bodyStringified,
        headers: headers,
    });
}

export const postFormData = <T>(url: string, file: any) => {

    let headers: Headers = new Headers();

    const data = new FormData();
    data.append('file', file);

    return fetch(url,
        {
            headers: headers,
            method: 'put',
            body: data
        })
        // .then(response => parseJSON<T>(response))
        .then(data => {
            return {
                success: true,
                data: data
            };
        })
        .catch(error => {
            return {
                success: false,
                error: error.message
            };
        })
}

export const downloadFile = (url: string): Promise<Blob> => {

    // Setup authorization:
    let headers = new Headers();
    const token: string = getToken() || '';
    headers.append('Authorization', `Bearer ${token}`);

    // Ajax fetch the url with Authorization Header
    return fetch(url, { headers })
        // Convert the 'text/csv' response to a blob
        .then(response => response.blob());
}

export function httpRequest<T>(requestUrl: string, method: string = 'get', body?: any): Promise<ApiResult<T>> {
    let request = buildRequest(requestUrl, method, body);
    // console.log(request)
    return fetch(request)
        .then(response => {
            if (response.status >= 200 && response.status < 300 && response.status !== 204) {
                // status 204 is NoContent, so don't try and parse it
                return response.json()
                    .then(data => {
                        let result: ApiResult<T> = { success: true, data: data, error: undefined }
                        return result;
                    });
            } else if (response.status === 204) {
                // No Content
                let result: ApiResult<T> = { success: true, data: undefined, error: undefined }
                return result;
            } else if (response.status === 500) {
                // API had an error response should be of type ErrorResult. Parse it and return to caller
                return response.json()
                    .then(apiError => {
                        let result: ApiResult<T> = { success: false, data: undefined, error: apiError }
                        return result;
                    });
            } else if (response.status === 400) {
                // Bad Request
                return response.json()
                .then(apiError => {
                    let result: ApiResult<T> = { success: false, data: undefined, error: apiError }
                    return result;
                });
            } else if (response.status === 401) {
                // Unauthorized
                let err: ErrorResult = { detail: `You must log in to access '${requestUrl}'`, message: 'Not Authorized' };
                let result: ApiResult<T> = { success: false, data: undefined, error: err }
                return result;
            } else if (response.status === 403) {
                // Unauthorized
                let err: ErrorResult = { detail: `User does not have permissions to access '${requestUrl}'`, message: 'Not Authorized' };
                let result: ApiResult<T> = { success: false, data: undefined, error: err }
                return result;
            } else if (response.status === 404) {
                // URL Not found
                let err: ErrorResult = { detail: `URL '${requestUrl}' not found on API controller`, message: 'Not Found' };
                let result: ApiResult<T> = { success: false, data: undefined, error: err }
                return result;
            } else if (response.status === 405) {
                // Not Allowed (i.e. Tried to POST a GET route)
                let err: ErrorResult = { detail: `Not allowed to '${method}' URL '${requestUrl}'`, message: 'Not Allowed' };
                let result: ApiResult<T> = { success: false, data: undefined, error: err }
                return result;
            } else {
                let err: ErrorResult = { detail: 'Unhandled http result status', message: 'API Fetch failed' };
                let result: ApiResult<T> = { success: false, data: undefined, error: err }
                return result;
            }
        })
        .catch(e => {
            let details = 'General exception caught in api-shared.ts. Things to check: API URL, API is running, Requested API route...';
            let err: ErrorResult = { detail: details, message: e };
            let result: ApiResult<T> = { success: false, data: undefined, error: err }
            return result;
        });
}

// promise used during automatic token refresh attempts
// let tokenRefreshPromise: Promise<void> | null = null;

// function updateRequestAuth(request: Request) {
//     if (request.headers.has('Authorization')) {
//         request.headers.delete('Authorization');
//     }
//     request.headers.append('Authorization', `Bearer ${authApi.getToken()}`);
//     return request;
// }

// function checkTokenExpiration(request: Request, initialResponse: Response)
//     : Promise<Response> {
//     if (initialResponse.status === 401 && initialResponse.headers.has('www-authenticate') &&
//         initialResponse.headers.get('www-authenticate')!.includes('error_description="The token is expired"')) {

//         if (!tokenRefreshPromise) {
//             let refreshRequest = buildRequest(`${BASE_URL}${REFRESH_URL}`,
//                                               'post',
//                                                 authApi.getRefreshToken()
//                                               );
//             tokenRefreshPromise = fetch(refreshRequest)
//                 .then((response) => checkStatus(response))
//                 .then((response) => parseJSON<LogInResponse>(response))
//                 .then((data) => {
//                     authApi.setTokens(data!);
//                     tokenRefreshPromise = null;
//                 })
//                 .catch((error) => {
//                     console.log(error)
//                     console.log("Error with Token")
//                     tokenRefreshPromise = null;
//                     authApi.logout();
//                     window.location.reload();
//                 });
//         }

//         return tokenRefreshPromise
//             .then(() => {
//                 return fetch(updateRequestAuth(request));
//             });
//     }
//     return Promise.resolve(initialResponse);
// }